import { Trans } from "@lingui/react/macro";
import clsx from "clsx";
import { observer } from "mobx-react-lite";

import { Button } from "../../../components/ui-kit/button";
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "../../../components/ui-kit/dialog";
import { AdminConsole } from "../admin-console";
import styles from "./temporary-password-dialog.module.css";

export const TemporaryPasswordDialog = observer(
  function TemporaryPasswordDialog(props: { admin: AdminConsole }) {
    return (
      <Dialog
        open={props.admin.tempPasswordPopup}
        onOpenChange={(open) =>
          !open && void props.admin.closeTemporaryPasswordPopup()
        }
        dismissible={false}
      >
        <DialogHeader>
          <Trans>Temporary password for patient:</Trans>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4">
          <p className={clsx(styles.password, "self-start")}>
            {props.admin.tempPasswordText}
          </p>
          <p>
            <Trans>
              (Password is valid for <strong>2 days</strong>, in the meantime,
              patient has to change it.)
            </Trans>
          </p>
          <p>
            <strong>
              <Trans>
                Save this password somewhere, as it cannot be shown again.
              </Trans>
            </strong>
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="primary"
            onClick={async () => {
              await props.admin.closeTemporaryPasswordPopup();
            }}
          >
            <Trans>OK</Trans>
          </Button>
        </DialogFooter>
      </Dialog>
    );
  },
);
